(function () {
  function ready(fn) {
    if (document.readyState === 'loading' || document.readyState === 'interactive') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function toArray(nl) { return Array.prototype.slice.call(nl); }

  function toNum(v) {
    if (typeof v === 'number') return isNaN(v) ? null : v;
    if (typeof v === 'string' && v.trim() !== '') {
      var n = parseFloat(v.replace(/\s/g, '').replace(',', '.').replace(/[^0-9.\-]/g, ''));
      return isNaN(n) ? null : n;
    }
    return null;
  }

  function fmt(value, currency) {
    var n = toNum(value);
    if (n !== null && window.MGMFunnel && MGMFunnel.formatPrice) {
      var out = MGMFunnel.formatPrice(n, currency);
      if (out) return out;
    }
    if (typeof value === 'string' && value.trim() !== '') return value;
    return '';
  }

  function syncTotal() {
    if (window.MGMUpdateUpsellTotal) {
      try { window.MGMUpdateUpsellTotal(); } catch (e) {}
    }
  }

  function buildCard(offer, index) {
    var priceNum = toNum(offer.price);
    var compareNum = toNum(offer.compare_price);
    var priceStr = fmt(offer.price, offer.currency);
    var hasCompare = compareNum !== null && (priceNum === null || compareNum > priceNum);
    var compareStr = hasCompare ? fmt(offer.compare_price, offer.currency) : '';

    var card = document.createElement('div');
    card.className = 'mgm-upsell-card';
    card.setAttribute('data-upsell-variant-id', offer.variant_id);
    card.setAttribute('data-upsell-price', priceStr);
    card.setAttribute('data-upsell-is-free', 'false');
    card.setAttribute('data-mgm-api-offer', offer.offer_id != null ? offer.offer_id : '');

    var cbId = 'mgm-api-upsell-' + index;

    var cbWrap = document.createElement('div');
    cbWrap.className = 'mgm-upsell-card__checkbox-wrapper';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'mgm-upsell-card__checkbox';
    cb.id = cbId;
    cb.setAttribute('data-upsell-variant-id', offer.variant_id);
    cb.setAttribute('data-upsell-price', priceStr);
    cb.setAttribute('data-upsell-is-free', 'false');
    cb.setAttribute('data-mgm-stage', 'sales');
    cb.setAttribute('data-mgm-offer', offer.offer_id != null ? String(offer.offer_id) : '');
    cb.setAttribute('aria-label', 'Ajouter ' + (offer.title || '') + ' au panier');
    var lbl = document.createElement('label');
    lbl.setAttribute('for', cbId);
    lbl.className = 'mgm-upsell-card__checkmark';
    cbWrap.appendChild(cb);
    cbWrap.appendChild(lbl);

    var content = document.createElement('div');
    content.className = 'mgm-upsell-card__content';

    if (offer.image) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'mgm-upsell-card__image-wrapper';
      var img = document.createElement('img');
      img.className = 'mgm-upsell-card__image';
      img.src = offer.image;
      img.alt = offer.title || '';
      img.loading = 'lazy';
      img.width = 60;
      img.height = 60;
      imgWrap.appendChild(img);
      content.appendChild(imgWrap);
    }

    var info = document.createElement('div');
    info.className = 'mgm-upsell-card__info';
    var h5 = document.createElement('h5');
    h5.className = 'mgm-upsell-card__title';
    h5.textContent = offer.title || '';
    info.appendChild(h5);

    var pricing = document.createElement('div');
    pricing.className = 'mgm-upsell-card__pricing';
    var pSpan = document.createElement('span');
    pSpan.className = 'mgm-upsell-card__price';
    pSpan.textContent = priceStr;
    pricing.appendChild(pSpan);
    if (compareStr) {
      var cSpan = document.createElement('span');
      cSpan.className = 'mgm-upsell-card__compare-price';
      cSpan.textContent = compareStr;
      pricing.appendChild(cSpan);
    }
    if (offer.discount_pct) {
      var dSpan = document.createElement('span');
      dSpan.className = 'mgm-upsell-card__discount';
      dSpan.textContent = '-' + offer.discount_pct + '%';
      pricing.appendChild(dSpan);
    }
    info.appendChild(pricing);
    content.appendChild(info);

    card.appendChild(cbWrap);
    card.appendChild(content);

    cb.addEventListener('change', syncTotal);
    card.addEventListener('click', function (e) {
      if (e.target.matches('.mgm-upsell-card__checkbox') || e.target.matches('.mgm-upsell-card__checkmark')) return;
      if (!cb.disabled) {
        cb.checked = !cb.checked;
        cb.dispatchEvent(new Event('change'));
      }
    });

    return card;
  }

  function separator() {
    var sep = document.createElement('div');
    sep.className = 'mgm-upsell-separator';
    sep.innerHTML = '<span>+</span>';
    return sep;
  }

  function applyOffers(container, offers) {
    toArray(container.querySelectorAll('.mgm-upsell-card, .mgm-upsell-separator, .mgm-upsell-skeleton')).forEach(function (n) { n.remove(); });
    container.removeAttribute('data-mgm-upsell-loading');
    offers.forEach(function (offer, i) {
      if (i > 0) container.appendChild(separator());
      container.appendChild(buildCard(offer, i));
    });
    container.setAttribute('data-mgm-api-applied', 'true');
    syncTotal();
    trackImpressions(offers);
  }

  var SKELETON_COUNT = 3;

  function injectSkeletonStyles() {
    if (document.getElementById('mgm-upsell-skeleton-style')) return;
    var style = document.createElement('style');
    style.id = 'mgm-upsell-skeleton-style';
    style.textContent = [
      '.mgm-upsells [data-mgm-upsell-hidden]{display:none !important;}',
      '.mgm-upsell-skeleton{display:flex;align-items:center;gap:1.4rem;padding:1.4rem;border:1px solid rgba(0,0,0,0.08);border-radius:1.2rem;background:#fff;}',
      '.mgm-upsell-skeleton__check{width:2.2rem;height:2.2rem;border-radius:50%;flex:0 0 auto;}',
      '.mgm-upsell-skeleton__img{width:6rem;height:6rem;border-radius:0.8rem;flex:0 0 auto;}',
      '.mgm-upsell-skeleton__info{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:0.8rem;}',
      '.mgm-upsell-skeleton__line{height:1.2rem;border-radius:0.4rem;}',
      '.mgm-upsell-skeleton__line--title{width:70%;}',
      '.mgm-upsell-skeleton__line--desc{width:92%;height:1rem;}',
      '.mgm-upsell-skeleton__line--price{width:42%;height:1.5rem;margin-top:0.2rem;}',
      '.mgm-skeleton-shimmer{background:linear-gradient(90deg,#ececec 25%,#f5f5f5 37%,#ececec 63%);background-size:400% 100%;animation:mgm-skeleton-shimmer 1.4s ease infinite;}',
      '@keyframes mgm-skeleton-shimmer{0%{background-position:100% 50%;}100%{background-position:0 50%;}}',
      '@media (prefers-reduced-motion:reduce){.mgm-skeleton-shimmer{animation:none;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function skelBlock(cls) {
    var el = document.createElement('span');
    el.className = 'mgm-upsell-skeleton__' + cls + ' mgm-skeleton-shimmer';
    return el;
  }

  function buildSkeletonCard() {
    var card = document.createElement('div');
    card.className = 'mgm-upsell-skeleton';
    card.setAttribute('data-mgm-skeleton', '');

    card.appendChild(skelBlock('check'));
    card.appendChild(skelBlock('img'));

    var info = document.createElement('div');
    info.className = 'mgm-upsell-skeleton__info';
    var title = document.createElement('span');
    title.className = 'mgm-upsell-skeleton__line mgm-upsell-skeleton__line--title mgm-skeleton-shimmer';
    var desc = document.createElement('span');
    desc.className = 'mgm-upsell-skeleton__line mgm-upsell-skeleton__line--desc mgm-skeleton-shimmer';
    var price = document.createElement('span');
    price.className = 'mgm-upsell-skeleton__line mgm-upsell-skeleton__line--price mgm-skeleton-shimmer';
    info.appendChild(title);
    info.appendChild(desc);
    info.appendChild(price);
    card.appendChild(info);

    return card;
  }

  function skeletonSeparator() {
    var s = separator();
    s.setAttribute('data-mgm-skeleton', '');
    return s;
  }

  function showSkeleton(container) {
    injectSkeletonStyles();
    toArray(container.querySelectorAll('.mgm-upsell-card, .mgm-upsell-separator')).forEach(function (n) {
      n.setAttribute('data-mgm-upsell-hidden', '');
    });
    var frag = document.createDocumentFragment();
    for (var i = 0; i < SKELETON_COUNT; i++) {
      if (i > 0) frag.appendChild(skeletonSeparator());
      frag.appendChild(buildSkeletonCard());
    }
    container.appendChild(frag);
    container.setAttribute('data-mgm-upsell-loading', 'true');
  }

  function hideSkeleton(container, restore) {
    toArray(container.querySelectorAll('[data-mgm-skeleton]')).forEach(function (n) { n.remove(); });
    if (restore) {
      toArray(container.querySelectorAll('[data-mgm-upsell-hidden]')).forEach(function (n) {
        n.removeAttribute('data-mgm-upsell-hidden');
      });
    }
    container.removeAttribute('data-mgm-upsell-loading');
  }

  function trackImpressions(offers) {
    if (!window.MGMFunnel || !MGMFunnel.cart || !MGMFunnel.event) return;
    MGMFunnel.cart().then(function (cart) {
      offers.forEach(function (o) { MGMFunnel.event(cart.token, o, 'sales', 'impression', 0); });
    }).catch(function () {});
  }

  function run() {
    if (!window.MGMFunnel || !MGMFunnel.salesOffers) return;
    toArray(document.querySelectorAll('.mgm-upsells[data-upsell-product-id]')).forEach(function (container) {
      var pid = container.getAttribute('data-upsell-product-id');
      if (!pid) return;
      if (container.querySelector('.mgm-upsell-card')) showSkeleton(container);
      MGMFunnel.salesOffers(pid).then(function (offers) {
        if (offers && offers.length) applyOffers(container, offers);
        else hideSkeleton(container, true);
      }).catch(function () {
        hideSkeleton(container, true);
      });
    });
  }

  ready(run);
})();
